import { Component, inject } from '@angular/core';
import { PageHeaderComponent } from '@/components/shared/page-header/page-header.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { DacInspectContentBlockComponent } from './content-block/content-block.component';

@Component({
  selector: 'sm-inspect-dac',
  standalone: true,
  imports: [PageHeaderComponent, CommonModule, TranslateModule, DacInspectContentBlockComponent],
  templateUrl: './inspect-dac.component.html',
  styleUrl: './inspect-dac.component.scss',
})
export class InspectDacComponent {
  private readonly activatedRoute = inject(ActivatedRoute);

  breadcrumb = [
    { label: 'ao.plural', routerLink: ['/call-for-tender'] },
    { label: 'ao.singular', routerLink: ['/edit-call-for-tender'] },
    { label: 'dac.title' },
  ];

  id: number = this.activatedRoute.snapshot.params['id'] as number;
  version: number = this.activatedRoute.snapshot.params['version'] as number;

  setBreadcrumbElement = (index: number, attribute: 'label' | 'routerLink', value: string | string[]) => {
    if (index > this.breadcrumb.length) return;
    if (attribute === 'label') this.breadcrumb[index].label = value as string;
    else if (attribute === 'routerLink') this.breadcrumb[index].routerLink = value as string[];
  };
}
